
import { ChangeEvent } from "react";
import React, { FC, useEffect, useState, memo, useMemo } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import LotCheckBox from "../ui/lotCheckBox";
import { groupCuoc } from "./TongHopType";
import { GetDaiQuayTrongNgay } from "./dataUtils";
import { ReportType } from "../redux/TongHopSlice";
import "./TongHopDaiSelect.scss";
import { isCuPhapMb, isCuPhapMn } from "../utils/common";
import LotSelect from "../ui/lotSelect";
import store from "../store";

type OwnProps = {
    mienDaiCuocId: number;
    ngay: string;
    daiSelected: string[];
    groupSelected: string[];
    onDaiSelected: (dai: string, event: ChangeEvent<HTMLInputElement>) => void;
    onGroupCuocSelected: (group: string, event: ChangeEvent<HTMLInputElement>) => void;
    onDaiLoaded: (dais: string[]) => void;
    onLoadReport: (selectedReport?: ReportType) => void;
    onContactIdChanged?: (contactId: number) => void;
    isTongHop?: boolean;
    contactId?: number;
}

const TongHopDaiSelect: FC<OwnProps> = ({
    mienDaiCuocId,
    ngay,
    daiSelected,
    groupSelected,
    onDaiSelected,
    onGroupCuocSelected,
    onDaiLoaded,
    onLoadReport,
    isTongHop,
    contactId,
    onContactIdChanged,
}) => {
    const mienCuPhapId = Number(localStorage["mienCuPhapId"])
    const [state, setState] = useState({
        daiQuayTrongNgay: [] as string[],
        contactId: contactId
    })
    useEffect(() => {
        GetDaiQuayTrongNgay(mienDaiCuocId, ngay).then((data: string[]) => {
            setState(prev => ({
                ...prev, daiQuayTrongNgay: data,

            }))
            onDaiLoaded(data)
            //console.log(data)
        })
    }, [mienDaiCuocId, ngay])
    const renderKhachHang = useMemo(() => {
        const data: any = store.getState().contact.contactExtra
        const keys = Object.keys(data)
        const contacts = store.getState().contact.contactArrFull
        const filtered = contacts.filter((contact: any) => {
            const included = keys.includes(contact.contactId + "")
            return included
        })
        return (<div className="common-container-row">

            <div style="font-size:12px;">Khách</div>
            <LotSelect value={state.contactId} onChange={(event) => {
                onContactIdChanged && onContactIdChanged(Number(event.target.value))
            }
            }>
                <option value={0}>{"Mọi người"}</option>
                {filtered.map((contact: any) => {
                    return (
                        <option value={contact.contactId} selected={contact.contactId == contactId}>{contact.name}</option>
                    )
                })}
            </LotSelect>
        </div>
        )
    }, [])
    return (
        <>
            <div className="  chon-dai">
                {isTongHop && /* isCuPhapMb() && */ renderKhachHang}
                {isCuPhapMn() && state.daiQuayTrongNgay.map(dai => {
                    return (
                        <LotCheckBox text={dai} checked={daiSelected.includes(dai)}
                            value={dai}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                onDaiSelected(dai, e);
                            }}
                        ></LotCheckBox>
                    )
                })}
                {
                    (() => {
                        let tmp = []
                        for (let i = 0; i < 4 - state.daiQuayTrongNgay.length; i++)
                            tmp.push(<div></div>)
                        return tmp
                    })()
                }
                {/* {
                    (() => {
                        let ret = [];
                        for (let i = 0; i < 4 - state.daiQuayTrongNgay.length; i++) {
                            ret.push(<div></div>);
                        }
                        return ret
                    })()
                } */}
                {isCuPhapMn() && <div className=" dai-right-panel">
                    <Button round size="tiny" color="primary"
                        onClick={() => onLoadReport(undefined)}
                    >
                        <i className="fa-solid fa-rotate"></i>
                    </Button>
                </div>}
            </div>
            <div className={isCuPhapMn() ? "grid-group-cuoc " : "grid-group-cuoc-mb"}>
                {groupCuoc.map((group, index) => {
                    const result = []
                    if (isCuPhapMb() && index++ == 3) {
                        result.push(<div className=" dai-right-panel">
                            <Button round size="tiny" color="primary"
                                onClick={() => onLoadReport(undefined)}
                            >
                                <i className="fa-solid fa-rotate"></i>
                            </Button></div>)
                    }
                    result.push(
                        <LotCheckBox text={group} value={group}
                            checked={groupSelected.includes(group)}
                            onChange={(e) => {
                                onGroupCuocSelected(group, e)
                            }}
                        ></LotCheckBox>
                    )
                    return result;
                })}
                <div style="width:36px;"></div>
            </div>

        </>
    )
}

export default memo(TongHopDaiSelect)